import { isBefore, isFuture, isPast, add } from 'date-fns';
import gql from 'graphql-tag';
import { useEffect, useState } from 'react';
import { ContactDataIntercept } from '../providers/FeatureFlagsProvider';
import { parseLocalDate } from '../util/date-utils';
import { getFromStorage, setInStorage } from '../util/storage-utils';
import useAccountCustomer from './useAccountCustomer';

enum ContactType {
  MOB = 'MOB',
  PNP = 'PNP',
}
// This variable value is hardcoded in sign-in. Please don't change
const isContactDataModalDismissed = 'isContactDataModalDismissed';
export default ({
  isEnabled,
  startDate,
  endDate,
}: ContactDataIntercept = {}) => {
  const [open, setOpen] = useState(false);

  const setIsSessionDismissed = () => {
    setInStorage(isContactDataModalDismissed, 'true');
  };

  const { customer, loading } = useAccountCustomer();

  const {
    encryptedPersonId,
    personName,
    lastConfirmedDate,
    email,
    prefLanguage,
    contactDetails,
  } = customer || {};

  useEffect(() => {
    const isDismissedForSession = getFromStorage(isContactDataModalDismissed);
    if (isDismissedForSession) {
      setOpen(false);
      return;
    }
    if (isEnabled && !loading && startDate && endDate && encryptedPersonId) {
      const eventStart = parseLocalDate(startDate);
      const eventEnd = parseLocalDate(endDate);
      // because we're using dates with no timestamp, we need
      // to use eventEnd + 1 day to make it inclusive of today
      setOpen(
        !isFuture(eventStart) &&
          !isPast(add(eventEnd, { days: 1 })) &&
          (!lastConfirmedDate ||
            isBefore(parseLocalDate(lastConfirmedDate), eventStart)),
      );
    }
  }, [isEnabled, loading, startDate, endDate, encryptedPersonId]);

  return {
    open,
    setOpen,
    setIsSessionDismissed,
    contactData: {
      name: personName || '',
      email: email || '',
      prefLanguage: prefLanguage || '',
      phone: contactDetails?.find(
        contact => contact?.contactType === ContactType.PNP,
      )?.contactValue,
      mobile: contactDetails?.find(
        contact => contact?.contactType === ContactType.MOB,
      )?.contactValue,
    },
  };
};
